import { FC, useCallback } from 'react';
import { useState } from '@hookstate/core';
import { meta } from '../../stores/backend';
import { closeModal, openModal } from '../../stores/backend/meta';
import { FpeTokenModal as FpeTokenModalComponent } from '../../components/FpeTokenModal';
import { useBackendPayload } from '../../hooks/use-backend';

export const FpeTokenModal: FC = () => {
    const $meta = useState(meta);
    const { backendPayload } = useBackendPayload();

    const onClose = useCallback(() => {
        closeModal('fpeToken');
    }, []);

    const onUseNow = useCallback(() => {
        closeModal('fpeToken');
        openModal({ key: 'buy' });
    }, []);

    return (
        <FpeTokenModalComponent
            isOpen={$meta.modals.fpeToken.value}
            onAfterOpen={backendPayload.getAccountStatus}
            onClose={onClose}
            onUseNow={onUseNow}
            onSaveLater={onClose}
        />
    );
};
